import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';

import LoginSidebar from 'components/consumer/LoginSidebar/LoginSidebar';
import CtaLink from 'components/essentials/Cta/CtaLink';
import isClient from 'commons/isClient';
import useUserData from 'data-hooks/useUserData';

const ConsumerLoginSideBarLink = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const { isLoggedIn, loading } = useUserData();

  if (loading) {
    return null;
  }

  if (isLoggedIn) {
    return <Redirect to="/customer/orders" />;
  }

  return (
    <>
      <CtaLink
        to="/sign-in/"
        color="brand"
        size="sm"
        hasArrow
        onClick={evt => {
          if (isClient()) {
            evt.preventDefault();
            setSidebarOpen(true);
          }
        }}
      >
        {' '}
        Sign In to track your order
      </CtaLink>

      <LoginSidebar
        show={isSidebarOpen}
        onClose={() => {
          setSidebarOpen(false);
        }}
      />
    </>
  );
};

export default ConsumerLoginSideBarLink;
